import { compose } from "redux";
import { connect } from "react-redux";
import Lock from "@material-ui/icons/Lock";
import React, { PureComponent } from "react";
import Close from "@material-ui/icons/Close";
import Public from "@material-ui/icons/Public";
import { withStyles } from "@material-ui/core/styles";
import { NavLink, generatePath } from "react-router-dom";
import { Grid, ButtonBase, IconButton, Typography } from "@material-ui/core";

import {
  updateView,
  setUserDefaultView,
  deleteView,
} from "features/planner/planner.actions";

import routePaths from "app/routePaths";
import { VIEW_TYPES } from "features/planner/planner.constants";
import SortableListRow from "app/components/SortableList/SortableListRow";
import SortableListRowIcon from "app/components/SortableList/SortableListRowIcon";

class ViewSidePanelItem extends PureComponent {
  deleteView = () => {
    const { viewId, dispatchDeleteView } = this.props;
    dispatchDeleteView(viewId);
  };

  setUserDefaultView = () => {
    const { viewId, dispatchSetUserDefaultView } = this.props;
    dispatchSetUserDefaultView(viewId);
  };

  toggleViewType = () => {
    const { viewId, view, dispatchUpdateView } = this.props;

    dispatchUpdateView(
      viewId,
      view.update("type", type => (type + 1) % Object.keys(VIEW_TYPES).length),
    );
  };

  render() {
    const { viewId, view, classes, selected } = this.props;

    return (
      <SortableListRow
        selected={selected}
        classes={{
          rootBorder: classes.sortableListRowRootBorder,
        }}
      >
        <SortableListRowIcon
          component={ButtonBase}
          onClick={this.toggleViewType}
        >
          {view.get("type") === VIEW_TYPES.PRIVATE ? (
            <Lock color="secondary" />
          ) : (
            <Public color="secondary" />
          )}
        </SortableListRowIcon>
        <Grid
          xs
          item
          container
          component={NavLink}
          alignItems="center"
          className={classes.viewName}
          onClick={selected ? undefined : this.setUserDefaultView}
          to={generatePath(routePaths.view, { viewId })}
        >
          <Typography color={selected ? "secondary" : "initial"}>
            {view.get("name")}
          </Typography>
        </Grid>
        <Grid item>
          {!selected && (
            <IconButton onClick={this.deleteView}>
              <Close fontSize="small" />
            </IconButton>
          )}
        </Grid>
      </SortableListRow>
    );
  }
}

const styles = theme => ({
  viewName: {
    height: "100%",
    padding: `0 ${theme.spacing(2)}px`,
  },
  sortableListRowRootBorder: {
    borderStyle: "solid",
  },
});

export default compose(
  connect(null, {
    dispatchUpdateView: updateView,
    dispatchDeleteView: deleteView,
    dispatchSetUserDefaultView: setUserDefaultView,
  }),
  withStyles(styles),
)(ViewSidePanelItem);
